import React, {
  useContext,
  useEffect
} from 'react';

import {
  withRouter
} from 'react-router-dom';

import PackageTab from 'src/Components/Common/PackageTab/PackageTab';

import FibrePackageDetails from 'src/Components/Common/FibrePackageDetails/FibrePackageDetails';

import DiscountIcon from 'src/Common/SVG/DiscountIcon';

import {
  IncludedServiceComponent,
  NewCustomerSuccessIcon,
  PurplePromotionIcon
} from 'src/Components/Common';

import OrderDetails from 'src/Components/NewCustomerSuccessScreen/Components/OrderDetails';

import WhatHappensNext from 'src/Components/NewCustomerSuccessScreen/Components/WhatHappensNext';

import {
  SalesContext
} from '../../Context/SalesContext';

import {
  addBeforeloadEvent,
  filterNumbers,
  getDrivePackageImageURL,
  getSelectedProductsArrays,
  isMobileView,
  removeBeforeloadEvent
} from '../../Utility/utility';

import {
  tagOnSuccessPageLoad
} from '../../Tagging/NewCustomerTagging';

import {
  Heading,
  Text,
  Subtitle,
  HorizontalLine
} from '../../StyledComponents';

import './SuccessScreen.css';

const SuccessScreen = () => {

  const context = useContext(SalesContext);

  const discountMonthValue = context.selectedContractTerm?.discountTerm?.split(' ');

  const selectedPackageSpeed =
    filterNumbers(context.selectedPackage.download) +
    '/' +
    context.selectedPackage.upload;

  const selectedPackageData = {
    imageUrl: getDrivePackageImageURL(context.selectedPackage.provider),
    type: `Fibre ${ context.selectedPackage.dataCap.toLowerCase() }`,
    speed: selectedPackageSpeed,
    price: `R${ context.selectedPackage.productPrice.value } PM`,
    contractTerm: context.selectedContractTerm
  };

  const { taggingIdArray, taggingQtyArray, taggingPriceArray } = getSelectedProductsArrays(context.selectedPackage, context.selectedAdditionalServices, context.additionalServices);

  const selectedAdditionalServiceKeys = Object.keys(
    context.selectedAdditionalServices
  ).filter((e) => context.selectedAdditionalServices[e] === true);

  let selectedAdditionalServices = [];
  let additionalServicesVAS = [];

  if (context.additionalServices && context.additionalServices.serviceCategories) {
    context.additionalServices.serviceCategories.map((service) => {
      if (!service.offerId) {
        additionalServicesVAS.push(service);
      }
    });
  }

  if (additionalServicesVAS) {
    selectedAdditionalServices = additionalServicesVAS.filter((e) =>
      selectedAdditionalServiceKeys.find((key) => key === e.vasCategory)
    );
  }

  let deliveryAddress = '', contactPerson = '';

  try {
    if (context.deliveryAddressType?.toUpperCase() === 'To another address'.toUpperCase()) {
      deliveryAddress = `${ context.deliveryAddress.unitNumber ? context.deliveryAddress.unitNumber + ',' : '' } ${ context.deliveryAddress.buildingName ? context.deliveryAddress.buildingName + ',' : '' } ${ context.deliveryAddress.streetAddress }, ${ context.deliveryAddress.suburb }, ${ context.deliveryAddress.city }, ${ context.deliveryAddress.province }, ${ context.deliveryAddress.postalCode }`;
    } else {
      deliveryAddress = `${ context.installationAddress.unitNumber ? context.installationAddress.unitNumber + ',' : '' } ${ context.installationAddress.buildingName ? context.installationAddress.buildingName + ',' : '' } ${ context.installationAddress.streetNumber } ${ context.installationAddress.streetName }, ${ context.installationAddress.suburb }, ${ context.installationAddress.city }, ${ context.installationAddress.province }, ${ context.installationAddress.postalCode }`;
    }
    contactPerson = `${ context.userDetails?.firstName } ${ context.userDetails?.lastName } (${ context.userDetails?.contactNumber })`;
  } catch (error) {
    console.log(error);
  }

  useEffect(() => {

    tagOnSuccessPageLoad(
      context.userDetails.referenceNo || context.userDetails.quoteNumber,
      context.userDetails.contactNumber,
      taggingIdArray,
      taggingQtyArray,
      taggingPriceArray,
      context.isUserExisting
    );

    window.onpopstate = (e) => {
      e.preventDefault();
      window.location.href = '/vodacom/fibre/sales/leads';
    };

    removeBeforeloadEvent();
  }, []);

  useEffect(() => {
    addBeforeloadEvent();

    return () => {
      removeBeforeloadEvent();
    };
  }, []);

  const getContractTerm = () => {
    switch (context.selectedContractTerm.duration) {
    case '12 Months':
      return ('x 12');
    case '24 Months':
      return ('x 24');
    default:
      return ('');
    }
  };

  return (
    <div className="success-screen__container">

      <div className="success-screen__logo">
        <NewCustomerSuccessIcon />
      </div>

      <div className="success-screen__data">

        <Heading
          size="3rem"
          className="success-screen__heading">
          Thank you, {context.userDetails.firstName}!
        </Heading>

        <Text
          className="success-screen__subtitle"
          aligntext="text">
          Your order was successful and we can start preparing your order.
        </Text>

        <div className="success-screen__dash"></div>

        <Text
          className="success-screen__subtitle"
          aligntext="center">
          We’ve sent an email to{' '}

          <span style={{ fontWeight: 'bold' }}>
            {` ${ context.userDetails.email } `}
          </span>

          {' '}

          to confirm your order and delivery details.

          <br />

          Once your order is ready for delivery, our courier partner will
          contact you to confirm delivery.
        </Text>

        <br />

        <OrderDetails
          referenceNumber={
            context.userDetails.referenceNo || context.userDetails.quoteNumber
          }
          deliveryAddress={
            deliveryAddress
          }
          contactPerson={
            contactPerson
          }
        />

        <Subtitle>Your order</Subtitle>

        <HorizontalLine />

        <PackageTab data={selectedPackageData} />

        <FibrePackageDetails speed={selectedPackageData.speed} type={selectedPackageData.type}></FibrePackageDetails>

        {(context.selectedPackageType === 'Vodacom One Deals' || context.selectedPackageType === 'Premium Fibre Deals') && context.selectedContractTerm?.inclusions?.length > 0 ?

          <IncludedServiceComponent
            inclusionsList={context.selectedContractTerm?.inclusions}
            bgcolor="#FFFFF"
            isDevice={false}
          />

          :
          null
        }

        {isMobileView() &&

          <div className="mobile-price">

            {context.selectedContractTerm.discountTerm &&

              <p className='generic-discount-container review-order-discount'>
                <PurplePromotionIcon />
                <Text
                  lineheight="0"
                  fontWeight="700"
                  fontSize="14px"
                  color="#9C2AA0">

                  {'  '} R{context.selectedContractTerm.discountAmount} off for {discountMonthValue[0] === '1' ? '1 month' : `${ discountMonthValue[0] } months`}
                </Text>
              </p>
            }

            <Text
              style={context.selectedContractTerm.discountTerm ? { textAlign: 'right'} : {textAlign: 'right', width: '100%'}}
              fontSize="16px">

              <span style={{ fontWeight: 'bold' }}>
                R{context.selectedPackage.productPrice.value} {getContractTerm()}
              </span>
            </Text>
          </div>
        }

        {context.additionalVas ?

          context.additionalVas.map((item, index) => {
            if (item.category === 'superWifi') {

              return (
                <div key={index}>

                  <HorizontalLine />

                  <div className="additional-vas">

                    <div className="image-wrapper-success">
                      <img src={item.imgUrl} />
                    </div>

                    <div className="additional-vas-details">
                      <div className="tbyb-promotion-success">Try before you buy</div>
                      <div className="additional-vas-details-wrapper-success">
                        <div className="details-lte">
                          <p className="lte-text">{item?.displayName}</p>
                        </div>
                        <p className="quantity-additional-vas">Qty: 1</p>
                        <div className="wrapperAdditional">
                          <p
                            className="price-additional"
                          >
                            {item?.price} {parseInt(item?.contractTerm) ? 'PM' : ''}
                          </p>
                        </div>
                      </div>
                      <div className="new-customer-promotion-text-success">FREE 14-day trial</div>
                      <div className="new-customer-discount-text-wrapper">
                        <DiscountIcon/>
                        <div className="new-customer-discount-text">{item.discount}</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div key={index}>
                  <HorizontalLine />
                  <div className="additional-vas">
                    <div className="image-wrapper-success" style={ item.category === 'contractCover' ? {marginRight: '3em'} : ''}>
                      <img src={item.imgUrl} style={ item.category === 'contractCover' ? {width: '100%'} : ''} />
                    </div>
                    <div className="additional-vas-details">
                      <div className="additional-vas-details-wrapper-success">
                        <div className="details-lte">
                          <p className="lte-text">{item?.displayName}</p>
                        </div>
                        <div className="wrapperAdditional">
                          <p
                            className="price-additional"
                          >
                            {item?.price} {parseInt(item?.contractTerm) || item.category === 'contractCover' ? 'PM' : ''}
                          </p>
                        </div>
                      </div>
                      <div className="new-customer-promotion-text-success">{item.category === 'contractCover' ? 'Pays for your contract expenses in the event of death' : ''}</div>
                    </div>
                  </div>
                </div>
              );
            }
          })

          :
          null
        }

        <HorizontalLine />

        {selectedAdditionalServices.length > 0 ?

          <>
            <Subtitle >
                Additional services
            </Subtitle>

            <HorizontalLine />

            <PackageTab
              data={selectedAdditionalServices}
              hideTrash={true}
            />
            <HorizontalLine />
          </>

          :
          null
        }
      </div>

      <WhatHappensNext additionalServices={selectedAdditionalServices} />
    </div>
  );
};

export default withRouter(SuccessScreen);
